import React from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../CustomComponent/toast";
import StepRoutes from "../../Routes/steps_routes";
import SimpleButton from "../../Components/layouts/simple_button";
import performRequest from "../../api/request";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import { Form, Formik } from "formik";
import { CreateEmployeeFeedback } from "../../SchemaInfo/info";
import { employeeFeedbackSchema } from "../../Schemas/Employee Feedback/employee_feedback";
import Footer from "../../Components/Footer/footer";
import CustomRadioButton from "../../CustomComponent/custom_radio";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcInspection } from "react-icons/fc";

const AddEmployeeFeedback = () => {
  const navigate = useNavigate();

  const handleSubmit = (values, actions) => {
    performRequest("POST", "/employee/employeeFeedback/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast(
            "success",
            "Thank you for your feedback. We'll make some thoughtful improvements."
          );
          navigate(`/`);
        } else {
          Toast("error", "Error while creating feedback");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    {" "}
                    <FcInspection className="fs-2 me-1" />
                    Employee Feedback
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="ps-3 pt-3">
                <h1
                  className="text-center"
                  style={{
                    color: "rgb(131, 129, 69)",
                    fontWeight: "700",
                    fontSize: "30px",
                  }}
                >
                  Feedback Form
                </h1>
                <p
                  className="fs-3 pb-0 text-center"
                  style={{ color: "rgb(57, 57, 48)", fontWeight: "500" }}
                >
                  We would love to hear your thoughts, suggestions, concerns or
                  problems with anything so we can improve!
                </p>
                <div className="text-center">
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752557587/xpb4b57zcxuscosms20w_duecx3_ivwm6e.webp"
                    alt="feedback image"
                    style={{ height: "40px" }}
                  ></img>
                </div>
              </div>
              <hr></hr>
              <Formik
                initialValues={CreateEmployeeFeedback}
                validationSchema={employeeFeedbackSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 fs-3 required">
                          Feedback Type
                        </label>
                        <div className="w-100 col mb-2 ms-5 ms-lg-0 ms-md-0">
                          <div>
                            <label class="form-check form-check-inline">
                              <CustomRadioButton
                                name="feedbackType"
                                value="Comments"
                              ></CustomRadioButton>
                              <span class="form-check-label fs-3">
                                Comments
                              </span>
                            </label>
                            <label class="form-check form-check-inline">
                              <CustomRadioButton
                                name="feedbackType"
                                value="Suggestions"
                              ></CustomRadioButton>
                              <span class="form-check-label fs-3">
                                Suggestions
                              </span>
                            </label>
                            <label class="form-check form-check-inline">
                              <CustomRadioButton
                                name="feedbackType"
                                value="Questions"
                              ></CustomRadioButton>
                              <span class="form-check-label fs-3">
                                Questions
                              </span>
                            </label>
                            <label class="form-check form-check-inline w-sm-100 w-lg-0 w-md-0">
                              <CustomRadioButton
                                name="feedbackType"
                                value="Other"
                              ></CustomRadioButton>
                              <span class="form-check-label fs-3">Other</span>
                            </label>
                          </div>
                          {props.touched.feedbackType &&
                            props.errors.feedbackType && (
                              <p className="text-danger">
                                {props.errors.feedbackType}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 fs-3 required">
                          Describe Your Feedback
                        </label>
                        <div className="w-100 col">
                          <CustomTextArea name="feedback" rows="5" />
                          <div className="mt-2">
                            {props.touched.feedback &&
                              props.errors.feedback && (
                                <p className="text-danger">
                                  {props.errors.feedback}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        {/* <FormSubmitButton
                          buttonText="Submit Feedback"
                          className="btn btn-success"
                        /> */}
                        <button className="btn mx-1 mt-2 btn-success">
                          SUBMIT FEEDBACK
                        </button>
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AddEmployeeFeedback;
